import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=d5438704&scoped=true"
import script from "./serviceDetails.vue?vue&type=script&lang=js"
export * from "./serviceDetails.vue?vue&type=script&lang=js"
import style0 from "./serviceDetails.vue?vue&type=style&index=0&id=d5438704&prod&lang=css"
import style1 from "./serviceDetails.vue?vue&type=style&index=1&id=d5438704&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5438704",
  null
  
)

export default component.exports